import React,{ useState, useEffect } from 'react'
import axios from 'axios';
import { useParams } from 'react-router-dom';
import NotFoundPage from './NotFoundPage';
import Footer from './Footer';
import Loader from './Loader';
const BHome = () => {
  const { slug } = useParams();
  const [business, setBusiness] = useState(null);
  const [stars, setStars] = useState(0);
  const [formData, setFormData] = useState({ name: '', phone: '', review: '',rating: 0 });
  
  const handleStarClick = (rating) => {
    setStars(rating);

    setFormData({
      ...formData,
      rating: rating, // Set the rating to the selected star
    });

  };

  useEffect(() => {
    // Fetch business details using slug
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/business/${slug}`)
      .then((response) => setBusiness(response.data))
      .catch((error) => console.error('Error fetching business:', error));
  }, [slug]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/business/${slug}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
      })
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      }); 
      setTimeout(() => setLoading(false), 5000); // Adjust timing as needed

  }, [slug]);

  if (loading) {
    return (
      <Loader/>
    );
  }

  if (!business) return <div><NotFoundPage/></div>;
    
 
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevFormData) => {
        if (name === 'phone') {
          // Remove non-digit characters and extract the last 10 digits
          const phoneNumber = value.replace(/\D/g, "").slice(-10);
          return { ...prevFormData, [name]: phoneNumber };
        }
        return { ...prevFormData, [name]: value };
      });
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/review/post`, {
          business_id: business._id,
          reviewer_name: formData.name,
          reviewer_phone: formData.phone,
          rating: formData.rating,
          comments: formData.review,
        });
  
        console.log('Review posted successfully:', response.data);
        // Reset form or give a success message to the user
        setFormData({ name: '', phone: '', review: '' });
        window.open('/visitagain', '_self');
      } catch (error) {
        console.error('Error posting review:', error.response?.data || error.message);
      }
    };
  
    const redirectToGoogle = () => {
      const url_review = business.link;
      window.open(url_review, '_blank');

    };
    
    document.title = `${business.business_name.toUpperCase()} | ClickStar : Simplify Reviews, Amplify Stars`;
  return (
    <>
      <div className='max-h-[100vh] overflow-hidden mx-auto'>
        <div className="relative h-screen w-screen">
          <div className="absolute inset-0 grid grid-cols-2 grid-rows-2">
            <div className="red"></div>
            <div className="blue"></div>
            <div className="yellow"></div>
            <div className="green"></div>
          </div>
          <div className="absolute inset-0 flex justify-center items-center bg-white rounded-full z-10 custom">
            <div className="text-center p-8 max-w-2xl mx-auto ">

                
              <h1 className="text-2xl font-semibold text-gray-800 mb-4">Review us at </h1>
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/1200px-Google_2015_logo.svg.png" alt="" className='w-52 mx-auto' />
              <div className="mx-auto text-[#faaf00] text-2xl gap-3 flex justify-center">
                <i className="fa fa-star" aria-hidden="true"></i>
                <i className="fa fa-star" aria-hidden="true"></i>
                <i className="fa fa-star" aria-hidden="true"></i>
                <i className="fa fa-star" aria-hidden="true"></i>
                <i className="fa fa-star" aria-hidden="true"></i>
              </div>
              <h2 className="text-3xl font-semibold text-gray-800 my-6">{business.business_name.toUpperCase()}</h2>

              <h2 className="text-lg text-gray-800 mb-4">Please leave us a review</h2>
              
              <div className=" justify-center mb-3">
          {[1, 2, 3, 4, 5].map((star) => (
            <span
              key={star}
              className={`text-3xl cursor-pointer ${
                stars >= star ? 'text-yellow-500 ' : 'text-gray-400'
              }`}
              onClick={() => {
                handleStarClick(star);
                if (star > 3) {
                  redirectToGoogle();
                }
              }}
            >
              
              <i className={`fa fa-star  ${
                stars >= star ? 'fas' : ' fa-regular'
              }`} aria-hidden="true"></i>

            </span>
          ))}
          {stars > 0 && (
          <p className="text-center text-gray-600 mt-4">
            You rated {stars} {stars === 1 ? 'star' : 'stars'}.
          </p>
          )}
        </div>

        {stars > 0 && stars <= 3 && (
        <form
        id={business._id}
          onSubmit={handleSubmit}
          className="bg-white w-4/5 mx-auto rounded-lg p-4 shadow-md mb-4 space-y-1"
        >
          {/* <h3 className="text-lg font-bold text-gray-700">How Can We Improve?</h3> */}
          
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:ring-blue-500"
              placeholder="Your Name"
              required
            />
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-blue-500"
              placeholder="9999999999"
              required
            />
            <textarea
              name="review"
              value={formData.review}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-blue-500"
              placeholder="Your Review"
            ></textarea>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded-lg font-medium hover:bg-blue-700">
            Post Review
          </button>
        </form>
      )}
      <Footer/>
            </div>
            
          </div>
          
        </div>
      </div>
    </>
  )

}

export default BHome